// extracted by mini-css-extract-plugin
module.exports = {"container":"FiltersHeader_container__2rhzT","icon":"FiltersHeader_icon__1ejpt","btnGroup":"FiltersHeader_btnGroup__3h5ke"};